export default __webpack_public_path__ + "static/media/sticker-9.1cddb7ce.png";